"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_es_1 = require("lodash-es");
const getInsightsGeneratorApiUrl = () => {
    if (process.env.IG_API_URL && process.env.IG_API_URL != '') {
        return process.env.IG_API_URL;
    }
    else {
        throw new Error('[IG-API] Missing Environment Configuration. Take a look at environment variables');
    }
};
const getReportTemplateByName = (reportName, accessToken, callback, onError) => {
    try {
        fetch(`${getInsightsGeneratorApiUrl()}/api/v1/report/template?report_name=${reportName}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
            .then(response => response.json())
            .then(result => callback(result));
    }
    catch (e) {
        console.log(`getReportTemplateByName Error: ${e}`);
        onError && onError(e);
    }
};
const runReportTemplateById = (reportTemplateId, reportRunParams, accessToken, callback, onError) => {
    try {
        fetch(`${getInsightsGeneratorApiUrl()}/api/v1/report/template/${reportTemplateId}/run`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(reportRunParams),
            credentials: 'include',
        })
            .then(response => response.json())
            .then(result => callback(result));
    }
    catch (e) {
        console.log(`runReportTemplateById Error: ${e}`);
        onError && onError(e);
    }
};
const firstRunReportTemplate = (reportTemplateId, parameters, metadata, accessToken, callback, onError) => {
    try {
        fetch(`${getInsightsGeneratorApiUrl()}/api/v1/report/template/firstRun`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                reportTemplateId,
                parameters,
                metadata
            }),
            credentials: 'include',
        })
            .then(response => response.json())
            .then(result => callback(result));
    }
    catch (e) {
        console.log(`runReportTemplateById Error: ${e}`);
        onError && onError(e);
    }
};
const getReportRunProgress = (reportRunId, accessToken, callback, onError) => {
    try {
        fetch(`${getInsightsGeneratorApiUrl()}/api/v1/report/template/progress/${reportRunId}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
            .then(response => response.json())
            .then(result => callback(result));
    }
    catch (e) {
        console.log(`getReportRunProgress Error: ${e}`);
        onError && onError(e);
    }
};
const getMappingsPerReportRun = (reportRunId, accessToken, callback, onError) => {
    try {
        fetch(`${getInsightsGeneratorApiUrl()}/api/v1/report/run/mappings`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                reportRunId,
            }),
            credentials: 'include',
        })
            .then(response => response.json())
            .then(result => callback(result));
    }
    catch (e) {
        console.log(`getMappingsPerReportRun Error: ${e}`);
        onError && onError(e);
    }
};
const postNewMappings = (newMappings, accessToken, callback, onError) => {
    try {
        fetch(`${getInsightsGeneratorApiUrl()}/api/v1/report/run/process-pairs`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(newMappings),
            credentials: 'include',
        })
            .then(result => result.text())
            .then(result => callback(JSON.parse(result || '{}')))
            .catch((error) => {
            /**
            * TODO: This is not a proper way to handle error, in this case the issue is that the API
            * response takes more than a minute, that lead into a CORS error that displays a show stopper error
            * on UI that breaks the wizard flow. Under API that does not block the process, so the workaround is
            * to stop the exception/error propagation until API implements a async process, so at that time
            * we should remove this 'dirty' catch
            */
            console.error('Something went wrong with process-pairs call!. Check Network for more information');
            onError && onError(error);
        });
    }
    catch (e) {
        console.log(`postNewMappings Error: ${e}`);
        onError && onError(e);
    }
};
const getReportProgressFor = (reportIds, accessToken, callback, onError) => {
    try {
        const promiseList = [];
        lodash_es_1.default.each(reportIds, reportId => {
            promiseList.push(fetch(`${getInsightsGeneratorApiUrl()}/api/v1/report/template/progress/${reportId}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
            }));
        });
        Promise.all(promiseList)
            .then(results => {
            return Promise.all(lodash_es_1.default.map(results, result => result.json()));
        })
            .then(results => {
            callback(results);
        });
    }
    catch (e) {
        console.log(`getReportProgressFor Error: ${e}`);
        onError && onError(e);
    }
};
const Services = {
    getReportTemplateByName,
    runReportTemplateById,
    getReportRunProgress,
    firstRunReportTemplate,
    getMappingsPerReportRun,
    postNewMappings,
    getReportProgressFor
};
exports.default = Services;
